import * as tslib_1 from "tslib";

var _a;

import { DrilldownLevels, DrilldownLevelsList } from "../constants";
import { MetricUnitLabels } from "../constants";
import moment from 'moment-timezone';
import { toCustomDateRange } from './date-range';
var LEVEL_DATE_FORMATS = (_a = {}, _a[DrilldownLevels.YEAR] = 'YYYY', _a[DrilldownLevels.MONTH] = 'MMM', _a[DrilldownLevels.WEEK] = 'M/D', _a[DrilldownLevels.DAY] = 'M/D', _a[DrilldownLevels.HOUR] = 'ha', _a);
export var getNextLevel = function getNextLevel(level) {
  return DrilldownLevelsList[DrilldownLevelsList.indexOf(level) + 1];
};
export var getLevelFromDateRange = function getLevelFromDateRange(dateRange, timezone) {
  var customDateRange = toCustomDateRange(dateRange, timezone);
  var levelIndex = -1;

  while (DrilldownLevelsList[++levelIndex] && moment(customDateRange.end).diff(customDateRange.start, DrilldownLevelsList[levelIndex], true) <= 1) {}

  return DrilldownLevelsList[levelIndex];
};
export var getLevel = function getLevel(_a) {
  var drilldownPoint = _a.drilldownPoint,
      dateRange = _a.dateRange,
      timezone = _a.timezone;
  return drilldownPoint ? getNextLevel(drilldownPoint.level) : getLevelFromDateRange(dateRange, timezone);
};
export var isoLevel = function isoLevel(level) {
  return level === DrilldownLevels.WEEK ? 'isoWeek' : level;
};
export var getDateRangeFromDrilldownPoint = function getDateRangeFromDrilldownPoint(_a, timezone) {
  var level = _a.level,
      date = _a.date;
  return {
    start: moment(date).tz(timezone).startOf(isoLevel(level)).toISOString(),
    end: moment(date).tz(timezone).endOf(isoLevel(level)).toISOString()
  };
};
export var formatLevelDate = function formatLevelDate(level, date) {
  return moment(date).format(LEVEL_DATE_FORMATS[level]);
};
export var convertSecondsToDurationObject = function convertSecondsToDurationObject(rawSeconds) {
  var intSeconds = Math.floor(rawSeconds);
  return {
    hours: Math.floor(intSeconds / 3600),
    minutes: Math.floor(intSeconds % 3600 / 60),
    seconds: intSeconds % 3600 % 60
  };
};
export var convertSecondsToDurationString = function convertSecondsToDurationString(rawSeconds) {
  var parts = [];

  var _a = convertSecondsToDurationObject(rawSeconds),
      hours = _a.hours,
      minutes = _a.minutes,
      seconds = _a.seconds;

  if (hours) {
    parts.push(hours + "h");
  }

  if (minutes || hours && seconds) {
    parts.push(minutes + "m");
  }

  if (seconds) {
    parts.push(seconds + "s");
  }

  if (parts.length === 0) {
    return '0s';
  }

  return parts.join(' ');
};
export var isSameDayTime = function isSameDayTime(date, compareDate) {
  return date.date() === compareDate.date() && date.month() === compareDate.month() && date.year() === compareDate.year() && date.hour() === compareDate.hour() && date.minute() === compareDate.minute();
};
export var setDateRangeEndToNow = function setDateRangeEndToNow(dateRange) {
  if (dateRange.type !== 'relative') {
    dateRange = tslib_1.__assign({}, dateRange, {
      end: moment().toISOString()
    });
  }

  return dateRange;
};
export var convertCustomDateRangeToSeconds = function convertCustomDateRangeToSeconds(dateRange) {
  var start = dateRange.start,
      end = dateRange.end;
  return moment(end).diff(moment(start), 'seconds');
};
export var convertDateRangeToSeconds = function convertDateRangeToSeconds(dateRange, timezone) {
  switch (dateRange.type) {
    case 'absolute':
      return convertCustomDateRangeToSeconds(dateRange);

    case 'relative':
      return convertCustomDateRangeToSeconds(toCustomDateRange(dateRange, timezone));

    default:
      throw new Error('Invalid date range');
  }
};
var SECONDS_IN_MINUTES = 60;
var SECONDS_IN_HOUR = SECONDS_IN_MINUTES * 60;
var SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
var SECONDS_IN_WEEK = SECONDS_IN_DAY * 7;
export var convertToSeconds = function convertToSeconds(value, fromUnit) {
  switch (fromUnit) {
    case MetricUnitLabels.SECONDS:
      return value;

    case MetricUnitLabels.MINUTES:
      return value * SECONDS_IN_MINUTES;

    case MetricUnitLabels.HOURS:
      return value * SECONDS_IN_HOUR;

    case MetricUnitLabels.DAYS:
      return value * SECONDS_IN_DAY;

    case MetricUnitLabels.WEEKS:
      return value * SECONDS_IN_WEEK;

    default:
      return value;
  }
};
export var convertSecondsToUnit = function convertSecondsToUnit(seconds, unit) {
  switch (unit) {
    case MetricUnitLabels.SECONDS:
      return seconds;

    case MetricUnitLabels.MINUTES:
      return seconds / SECONDS_IN_MINUTES;

    case MetricUnitLabels.HOURS:
      return seconds / SECONDS_IN_HOUR;

    case MetricUnitLabels.DAYS:
      return seconds / SECONDS_IN_DAY;

    case MetricUnitLabels.WEEKS:
      return seconds / SECONDS_IN_WEEK;

    default:
      return seconds;
  }
};
export var convertToUnit = function convertToUnit(value, from, to) {
  return convertSecondsToUnit(convertToSeconds(value, from), to);
};